module.exports = "/_next/static/images/9896ff4619514b192855506d74dae05f-rewards-smiles@0.5x.png.webp";